import { Controller } from "@hotwired/stimulus"

// Auto-applies a GET filter form as the user changes it, in two modes:
//
//   selects  -> a full page visit, so anything outside the results frame that
//               reflects the current filters (summary cards, "clear filters")
//               re-renders with them. Nothing here holds a caret to lose.
//   search   -> the results frame only, debounced, so the input the user is
//               still typing in is never replaced mid-keystroke.
//
// The submit button stays in the markup as a no-JS fallback and hides on connect.
export default class extends Controller {
  static targets = ["submit", "status"]
  static values = {
    frame: String,
    delay: { type: Number, default: 350 }
  }

  connect() {
    this.submitTargets.forEach((button) => button.classList.add("hidden"))
    this.element.addEventListener("turbo:submit-start", this.showBusy)
    this.element.addEventListener("turbo:submit-end", this.hideBusy)
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.element.removeEventListener("turbo:submit-start", this.showBusy)
    this.element.removeEventListener("turbo:submit-end", this.hideBusy)
  }

  submit() {
    clearTimeout(this.timeout)
    this.element.setAttribute("data-turbo-frame", "_top")
    this.element.requestSubmit()
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.element.setAttribute("data-turbo-frame", this.frameValue)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  showBusy = () => {
    this.statusTargets.forEach((element) => element.classList.remove("invisible"))
  }

  hideBusy = () => {
    this.statusTargets.forEach((element) => element.classList.add("invisible"))
  }
}
